<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-6">
		        <label>Pedido *</label>
		        <select-two
		        	:options="pedidos"
		        	:formId="name+'pedido_id'"
		        	:valueDefault="clienteDefault"
		        	@selected="setPedidoId"
		        	@searching="getPedidos"
		        	@noValue="setPedidoId('')"
		        	arrayValue="nome">
		        </select-two>
		        <div class="invalid-feedback" :id="name+'pedido_id-invalid-feedback'"></div>
		    </div>
            <div class="form-group col-md-2">
		        <label>Ordem</label>
		        <input
		        	type="number"
		        	class="form-control"
		        	v-model="dados.ordem"
		        	:id="name+'ordem'">
		        <div class="invalid-feedback" :id="name+'ordem-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-2">
		        <label>C.E.P.</label>
		        <input
		        	type="text"
		        	v-mask="'#####-###'"
		        	class="form-control"
		        	v-model="dados.cep"
		        	:id="name+'cep'"
		        	@input="searchCep('cep')">
		        <div class="invalid-feedback" :id="name+'cep-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Bairro</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.bairro"
		        	:id="name+'bairro'"
		        	@input="clearValidation('bairro')">
		        <div class="invalid-feedback" :id="name+'bairro-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>Cidade</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.cidade"
		        	:id="name+'cidade'"
		        	@input="clearValidation('cidade')">
		        <div class="invalid-feedback" :id="name+'cidade-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-3">
		        <label>Estado</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-mask="'AA'"
		        	v-model="dados.estado"
		        	:id="name+'estado'"
		        	@input="clearValidation('estado')">
		        <div class="invalid-feedback" :id="name+'estado-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Logradouro</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.logradouro"
		        	:id="name+'logradouro'"
		        	@input="clearValidation('logradouro')">
		        <div class="invalid-feedback" :id="name+'logradouro-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Complemento</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.complemento"
		        	:id="name+'complemento'"
		        	@input="clearValidation('complemento')">
		        <div class="invalid-feedback" :id="name+'complemento-invalid-feedback'"></div>
		    </div>
		</div>
	</div>
</template>



<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados),
                pedidos: [],
                clienteDefault: null
			}
		},
        created(){
            if(this.dados.pedido){
                this.clienteDefault = this.dados.pedido.cliente
            }
            this.getPedidos();
        },
		methods : {
            getPedidos(pesquisa=''){
				axios.get(this.$url+'/api/adm/entrega-destinos/pedido_list?pesquisa='+pesquisa)
	            .then(response => {
	                this.pedidos = response.data.data.data
	            })
			},
			setPedidoId(valor){
				this.dados.pedido_id = valor.id;
                this.getClienteEndereco()
			},
            getClienteEndereco(){
                let cliente_id = null
                for(var i=0; i<this.pedidos.length; i++){
                    if(this.pedidos[i]['id'] == this.dados.pedido_id){
                        cliente_id = this.pedidos[i]['cliente_id']
                    }
                }
                if(cliente_id){
                    axios.get(this.$url+'/api/adm/clientes/show/'+cliente_id)
                    .then(response => {
                        this.dados.cep = response.data.data.cep
                        this.dados.cidade = response.data.data.cidade
                        this.dados.bairro = response.data.data.bairro
                        this.dados.estado = response.data.data.estado
                        this.dados.logradouro = response.data.data.logradouro
                        this.dados.complemento = response.data.data.complemento
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            },
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			},
			searchCep(element){
				if(this.dados.cep.length == 9){
					axios.get('http://viacep.com.br/ws/'+this.dados.cep+'/json')
		            .then(response => {
		            	this.dados.bairro = response.data.bairro
		            	this.dados.cidade = response.data.localidade
		            	this.dados.estado = response.data.uf
		            	this.dados.logradouro = response.data.logradouro
		            })
		            .catch(error => {
		            	console.log(error)
		            });
		        }
		        this.clearValidation(element);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
